import NumberFormat from 'react-number-format';

export const thousandSeparatorWithTLSeperator = (props: any) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      suffix="₺"
      decimalSeparator={false}
      thousandSeparator
    />
  );
};
